import React from 'react'
import ContributorGroupListPage from './ContributorGroupListPage'

const contributorGroupRoutes = [
  {
    breadcrumb: 'contributorGroups',
    path: '',
    element: <ContributorGroupListPage />,
    children: [],
  },
]

export default contributorGroupRoutes
